import { IQueryParams } from "./common.types";

export const getSearchQuery = (queryParams: IQueryParams): string => {
  const {
    page,
    rowsPerPage,
    billing_company_uuid,
    status,
    value,
    columns,
    fromDate,
    toDate,
    product_uuid,
  } = queryParams;
  let query = "?";
  if (product_uuid) {
    query += `product_uuid=${product_uuid}&`;
  }
  if (billing_company_uuid) {
    query += `billing_company_uuid=${billing_company_uuid}&`;
  }
  if (status && status !== "-1") {
    query += `status=${status}&`;
  }
  if (columns && columns.length > 0 && value && value.length > 0) {
    query += `columns=${columns}&`;
  }
  if (columns && columns.length > 0 && value && value.length > 0) {
    query += `value=${encodeURIComponent(value)}&`;
  }
  if (fromDate) {
    query += `from_date=${fromDate}&`;
  }
  if (toDate) {
    query += `to_date=${toDate}&`;
  }
  query += `pageNo=${page}&itemPerPage=${rowsPerPage}`;
  return query;
};
